export enum EPreconversationType {
  EMAIL = 'email',
  TEXT = 'text'
}

export enum EPersonaViewMode {
  ON_CALL = 'ON_CALL',
  BEFORE_CALL = 'BEFORE_CALL',
  POST_CALL = 'POST_CALL'
}

export enum EPersonaIntegrationMode {
  EMBED = 'EMBED',
  WIDGET = 'WIDGET'
}
export interface IPerconversationField {
  label: string;
  name: string;
  type: EPreconversationType;
  value: string;
}

export interface IPreconversationConfig {
  fields: IPerconversationField[];
}

export interface IPersonaEmbedSettings {
  video_agent_name: string;
  is_form_enabled: boolean;
  description: string;
  button_text: string;
  second_button_text: string;
  powered_by: boolean;
  dark_mode: boolean;
  main_color: string;
  more_personalised_colors: boolean;
  font: string;
  camera: boolean;
  language_selection: boolean;
  captions_by_default: boolean;
  domains: string[];
  type: EIntegrationSettingsType;
  api_key_id: string;
  screen_share: boolean;
  cta_primary_button_text: string;
  cta_secondary_button_text: string;
  cta_secondary_button_link: string;
  video_call_ended_custom_message: string;
  cta_primary_button_link: string;
}

export interface IPersonaWidgetSettings {
  video_agent_name: string;
  is_form_enabled: boolean;
  description: string;
  button_text: string;
  second_button_text: string;
  powered_by: boolean;
  main_color: string;
  more_personalised_colors: boolean;
  dark_mode: boolean;
  font: string;
  camera: boolean;
  language_selection: boolean;
  captions_by_default: boolean;
  domains: string[];
  type: EIntegrationSettingsType;
  api_key_id: string;
  welcome_button_color: string;
  bubble_background_color: string;
  bubble_icon_variant: string;
  bubble_icon_custom: boolean;
  bubble_icon_color: string;
  bubble_icon_url: string;
  bubble_icon_side: 'left' | 'right';
  custom_widget_trigger: string;
  screen_share: boolean;
  cta_primary_button_text: string;
  cta_secondary_button_text: string;
  cta_secondary_button_link: string;
  video_call_ended_custom_message: string;
  cta_primary_button_link: string;
}

export interface ITavusPersonaFormik {
  isRecording: boolean;
  personaIntegrationViewMode: EPersonaIntegrationMode;
  personaViewMode: EPersonaViewMode;
  name: string;
  defaultReplicaId: string;
  systemPrompt: string;
  context: string;
  customGreeting: string;
  timer_config_enabled: boolean;
  custom_background: string | null;
  model: string;
  timer_config: ITimerConfig | string;
  voiceId: string;
  preconversationConfig: IPreconversationConfig;
  defaultLanguage: string;
  perceptionModel: string;
  ambientAwarenessQueries: string[];
  embed: IPersonaEmbedSettings;
  widget: IPersonaWidgetSettings;
}

export interface ICreateTavusPersonaReq {
  persona_name: string;
  context: string;
  isRecording: boolean;
  system_prompt: string;
  default_replica_id: string;
  custom_background?: string | null;
  timer_config_enabled: boolean;
  custom_greeting?: string;
  model: string;
  timer_config: ITimerConfig | string;
  preconversation_config?: IPreconversationConfig;
  ambient_awareness_queries?: string[];
  perception_model?: string;
  voice_id: string;
  default_language: string;
  embed: IPersonaEmbedSettings;
  widget: IPersonaWidgetSettings;
}

export interface ICreateTavusPersonaRes {
  persona_id: string;
  persona_name: string;
  created_at: string;
}

interface FunctionParameters {
  type: string;
  properties: {
    location: {
      type: string;
      description: string;
    };
    unit: {
      type: string;
      enum: string[];
    };
  };
  required: string[];
}

interface ToolFunction {
  name: string;
  description: string;
  parameters: FunctionParameters;
}

interface Tool {
  type: string;
  function: ToolFunction;
}

interface LLM {
  model: string;
  base_url: string;
  api_key: string;
  tools: Tool[];
}

interface VoiceSettings {
  speed: string;
  emotion: string[];
}

interface TTS {
  api_key: string;
  tts_engine: string;
  external_voice_id: string;
  voice_settings: VoiceSettings;
  playht_user_id: string;
}

interface VQA {
  enable_vision: string;
}

interface Layers {
  llm: LLM;
  tts: TTS;
  vqa: VQA;
}

interface ITimerConfig {
  duration: number;
  events: {
    type: 'echo' | 'end_call' | 'time_script' | 'llm_prompt';
    time_point: number;
    value?: string;
  }[];
}
export interface ITavusPersona {
  id: string;
  isRecording: boolean;
  persona_name: string;
  system_prompt: string;
  default_replica_id: string;
  custom_background: string;
  timer_config_enabled: boolean;
  context: string;
  layers: Layers;
  updated_at: string;
  user_id: string;
  custom_greeting?: string;
  model: string;
  timer_config: ITimerConfig;
  default_language: string;
  preconversation_config?: IPreconversationConfig;
  voice_id?: string;
  integration_settings?: IIntegrationSettings[] | null;
  perception_model?: string;
  ambient_awareness_queries?: string[];
  embed: IPersonaEmbedSettings;
  widget: IPersonaWidgetSettings;
}

export interface ListPersonas {
  items: ITavusPersona[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export enum EIntegrationSettingsType {
  WIDGET = 'widget',
  EMBED = 'embed'
}

export interface IIntegrationSettings {
  video_agent_name: string;
  is_form_enabled: boolean;
  description: string;
  button_text: string;
  powered_by: boolean;
  main_color: string;
  more_personalised_colors: boolean;
  dark_mode: boolean;
  font: string;
  camera: boolean;
  language_selection: boolean;
  captions_by_default: boolean;
  domains?: string[];
  welcome_button_color?: string;
  bubble_background_color?: string;
  bubble_icon_color?: string;
  bubble_icon_variant?: string;
  bubble_icon_custom?: boolean;
  bubble_icon_url?: string;
  dimensions?: {
    width: number;
    height: number;
  };
  type: EIntegrationSettingsType;
  bubble_icon_side?: 'left' | 'right';
  custom_widget_trigger?: string;
  api_key_id: string;
}
